document.addEventListener('DOMContentLoaded', () => {    
    // 見出しの取得
    const articleTitles = document.querySelectorAll('.tsumikiya_contents h2, .tsumikiya_contents h3, .tsumikiya_contents h4, .tsumikiya_contents h5, .tsumikiya_contents h6');

    // 見出しが4つ以上の時作成
    if ( articleTitles.length > 3 ) {
        createToc(articleTitles);
    }

});

const createToc = ( titles ) => {
    // 目次コンテンツの作成
    const tocContents = document.createElement('div');
    tocContents.classList.add('article_toc');
    const tocContentsOl = document.createElement('ol');

    let articleCount = 0;

    titles.forEach(title  => {
        articleCount ++;

        // 見出しタグ要素のidを取得し空の場合は内容をidにする
        let id = title.id;
        if(id === '') {
            id = `article_${articleCount}`;
            title.id = id;
        }

        // リストの要素作成
        const li = document.createElement('li');
        const a = document.createElement('a');

        // リスト内の最後のタグを取得する
        const lastTag = tocContentsOl.lastElementChild;

        // <li><a>タイトル</a></li>を作成
        a.textContent = title.textContent;
        a.href = '#' + title.id;
        li.appendChild(a);

        // 要素がh2タグの場合
        if(title.tagName === 'H2') {
            li.classList.add('article_toc_h2');
            // リストに追加
            tocContentsOl.appendChild(li);


        } else if(title.tagName === 'H3') { //h3の場合
            li.classList.add('article_toc_h3');
            // リストの最後の最後のタグ
            const lastTagLevel2 = lastTag.lastElementChild;

            if ( lastTagLevel2.classList.contains('article_toc_h3_lists') ) {
                lastTagLevel2.appendChild(li);
            } else {
                const ol = document.createElement('ol');
                ol.classList.add('article_toc_h3_lists');
                ol.appendChild(li);
                // article_toc_h2_listsの最後のリストにarticle_toc_h3_listsを追加する
                lastTag.appendChild(ol);
            }
        } else if(title.tagName === 'H4') { //h4の場合
            li.classList.add('article_toc_h4');
            const lastTagLevel2 = lastTag.lastElementChild;
            const lastTagLevel3 = lastTagLevel2.lastElementChild;
            const lastTagLevel4 = lastTagLevel3.lastElementChild;

            if ( lastTagLevel4.classList.contains('article_toc_h4_lists') ) {
                lastTagLevel4.appendChild(li);
            } else {
                const ol = document.createElement('ol');
                ol.classList.add('article_toc_h4_lists');
                ol.appendChild(li);
                // article_toc_h3_listsの最後のリストにarticle_toc_h4_listsへ追加する
                lastTagLevel3.appendChild(ol);
            }
        } else if(title.tagName === 'H5') { //h5の場合
            li.classList.add('article_toc_h5');
            const lastTagLevel2 = lastTag.lastElementChild;
            const lastTagLevel3 = lastTagLevel2.lastElementChild;
            const lastTagLevel4 = lastTagLevel3.lastElementChild;
            const lastTagLevel5 = lastTagLevel4.lastElementChild;
            const lastTagLevel6 = lastTagLevel5.lastElementChild;

            if ( lastTagLevel6.classList.contains('article_toc_h5_lists') ) {
                lastTagLevel6.appendChild(li);
            } else {
                const ol = document.createElement('ol');
                ol.classList.add('article_toc_h5_lists');
                ol.appendChild(li);
                lastTagLevel5.appendChild(ol);
            }
        } else if(title.tagName === 'H6') { //h6の場合
            li.classList.add('article_toc_h6');
            const lastTagLevel2 = lastTag.lastElementChild;
            const lastTagLevel3 = lastTagLevel2.lastElementChild;
            const lastTagLevel4 = lastTagLevel3.lastElementChild;
            const lastTagLevel5 = lastTagLevel4.lastElementChild;
            const lastTagLevel6 = lastTagLevel5.lastElementChild;
            const lastTagLevel7 = lastTagLevel6.lastElementChild;
            const lastTagLevel8 = lastTagLevel7.lastElementChild;

            if ( lastTagLevel8.classList.contains('article_toc_h6_lists') ) {
                lastTagLevel8.appendChild(li);
            } else {
                const ol = document.createElement('ol');
                ol.classList.add('article_toc_h6_lists');
                ol.appendChild(li);
                lastTagLevel7.appendChild(ol);
            }
        }
    });

    // 目次タグの生成
    const toc = document.createElement('div');
    toc.classList = 'article_toc_wrapper';

    // 目次の見出し作成
    const tocTitle = document.createElement('h2');
    tocTitle.classList = 'article_toc_title';
    tocTitle.textContent = '- 目次 -';
    toc.prepend(tocTitle);


    // 目次コンテンツの中に見出しリスト要素を追加する
    toc.appendChild(tocContents).appendChild(tocContentsOl);

    // 最初の見出し前に目次挿入
    for ( let title of titles ) {
        title.before(toc);
        break;
    }
}
